// Real data from Nitin Sharma Photography Portfolio - nsphotovideo.com

const wix = (uri) => `https://static.wixstatic.com/media/${uri}/v1/fill/w_800,h_534,al_c,q_85,enc_avif,quality_auto/${uri}`;
const wixTall = (uri) => `https://static.wixstatic.com/media/${uri}/v1/fill/w_600,h_900,al_c,q_85,enc_avif,quality_auto/${uri}`;
const wixHero = (uri) => `https://static.wixstatic.com/media/${uri}/v1/fill/w_1920,h_1080,al_c,q_90,enc_avif,quality_auto/${uri}`;

export const portfolioData = {
  hero: {
    title: "Nitin Sharma",
    subtitle: "Photography & Cinematography",
    tagline: "Capturing Timeless Moments with Artistic Vision",
    heroImage: wixHero("cb9bb3_f8f067d7906b46eb9d7385a2eb171ef2~mv2.jpg"),
    heroSlides: [
      wixHero("cb9bb3_f8f067d7906b46eb9d7385a2eb171ef2~mv2.jpg"),
      wixHero("cb9bb3_1b7c50ec1ff84808b999296e6f81d3e4~mv2.jpg"),
      wixHero("cb9bb3_462c371881364186b0c71ca7f8c350da~mv2_d_1800_1200_s_2.jpg"),
      wixHero("cb9bb3_c2442f3258494adc8c9469dd307ab056~mv2_d_1800_1200_s_2.jpeg"),
      wixHero("cb9bb3_16f5b21f235e4da1969928f0de3b912c~mv2_d_1800_1200_s_2.jpg"),
      wixHero("cb9bb3_4ce09065acce43a68640cfc6a384d5db~mv2_d_1800_1200_s_2.jpeg"),
    ]
  },

  about: {
    title: "About Nitin",
    description: "With over a decade of experience in photography and cinematography, I specialize in capturing the essence of life's most precious moments. My work is characterized by a unique blend of artistic vision and technical excellence, creating timeless images that tell compelling stories.",
    experience: "5+ Years",
    projects: "100+ Projects",
    clients: "25+ Happy Clients",
    awards: "15+ Awards"
  },

  services: [
    {
      id: 1,
      title: "Automotive Photography",
      description: "Premium automotive photography that captures the power, elegance, and craftsmanship of every machine. From supercars to classics.",
      icon: "Car",
      bgImage: wix("cb9bb3_c7b0cc00b7534b99b607ff7cc7151707~mv2_d_1800_1201_s_2.jpeg"),
      features: ["Product Shoots", "On-Location Sessions", "Detail Close-ups", "Lifestyle Automotive"]
    },
    {
      id: 2,
      title: "Wedding Photography",
      description: "Complete wedding coverage with cinematic storytelling, capturing every emotion and detail of your special day.",
      icon: "Heart",
      bgImage: wix("cb9bb3_1b7c50ec1ff84808b999296e6f81d3e4~mv2.jpg"),
      features: ["Full Day Coverage", "Pre-wedding Shoot", "Candid Photography", "Traditional Portraits"]
    },
    {
      id: 3,
      title: "Event Photography",
      description: "Professional coverage of corporate events, parties, and special occasions with dynamic and engaging imagery.",
      icon: "Calendar",
      bgImage: wix("cb9bb3_a27e0de08cdb472bb63a6ea6d7a10afe~mv2_d_1800_1200_s_2.jpg"),
      features: ["Corporate Events", "Birthday Parties", "Social Gatherings", "Live Coverage"]
    },
    {
      id: 4,
      title: "Food Photography",
      description: "Mouth-watering food photography that brings flavors to life through expertly styled and lit compositions.",
      icon: "UtensilsCrossed",
      bgImage: wix("cb9bb3_b74122c98be34a69bbb8630a6502c2d3~mv2_d_1800_1200_s_2.jpeg"),
      features: ["Restaurant Menus", "Brand Campaigns", "Editorial Food", "Packaging Photography"]
    },
    {
      id: 5,
      title: "Cinematography",
      description: "Cinematic video production with storytelling approach for weddings, events, and promotional content.",
      icon: "Video",
      bgImage: wix("cb9bb3_8573e6f1eaa24c339b8dac13ad1048e6~mv2_d_1800_1200_s_2.jpeg"),
      features: ["Wedding Films", "Event Videos", "Promotional Videos", "Documentary Style"]
    },
    {
      id: 6,
      title: "Portrait & Nature",
      description: "Stunning portraits and breathtaking nature photography capturing the beauty of people and the natural world.",
      icon: "Camera",
      bgImage: wix("cb9bb3_3d4cebb4a5294b65b082f4533ca77e58~mv2_d_1800_1200_s_2.jpg"),
      features: ["Individual Portraits", "Nature & Landscapes", "Creative Concepts", "Outdoor Sessions"]
    }
  ],

  portfolioCategories: [
    {
      id: 'automotive',
      name: 'Automotive',
      images: [
        { id: 1, url: wix("cb9bb3_f8f067d7906b46eb9d7385a2eb171ef2~mv2.jpg"), title: "Automotive Shot 1", category: "Automotive" },
        { id: 2, url: wix("cb9bb3_1f46aa9afc3047538ee08410e441925d~mv2.jpeg"), title: "Automotive Shot 2", category: "Automotive" },
        { id: 3, url: wix("cb9bb3_0bf4faa86d174cd78e1c1a545d5417fa~mv2.jpg"), title: "Automotive Shot 3", category: "Automotive" },
        { id: 4, url: wix("cb9bb3_c2946fa194fb42f389105e14b0ccfef7~mv2_d_1800_1201_s_2.jpeg"), title: "Automotive Shot 4", category: "Automotive" },
        { id: 5, url: wix("cb9bb3_c7b0cc00b7534b99b607ff7cc7151707~mv2_d_1800_1201_s_2.jpeg"), title: "Automotive Shot 5", category: "Automotive" },
        { id: 6, url: wixTall("cb9bb3_072340c96b3f48b29fc177b9941a8e69~mv2_d_1200_1798_s_2.jpeg"), title: "Automotive Shot 6", category: "Automotive" },
        { id: 7, url: wix("cb9bb3_63a8fedcb53f4b77919f96c15741c95f~mv2.jpg"), title: "Automotive Shot 7", category: "Automotive" },
        { id: 8, url: wix("cb9bb3_8573e6f1eaa24c339b8dac13ad1048e6~mv2_d_1800_1200_s_2.jpeg"), title: "Automotive Shot 8", category: "Automotive" },
        { id: 9, url: wixTall("cb9bb3_fb715820b73a45de8a8bca6a942796bf~mv2_d_1200_1800_s_2.jpeg"), title: "Automotive Shot 9", category: "Automotive" },
        { id: 10, url: wix("cb9bb3_2a25c27aa6cc4e99b59374810ac9d261~mv2_d_1800_1200_s_2.jpeg"), title: "Automotive Shot 10", category: "Automotive" },
        { id: 11, url: wix("cb9bb3_9774f7eeceba41ff91c55b0d60c509db~mv2_d_1800_1200_s_2.jpeg"), title: "Automotive Shot 11", category: "Automotive" },
        { id: 12, url: wix("cb9bb3_004d187faf6b4dda88fa1e7a8eb6fd28~mv2_d_1800_1200_s_2.jpeg"), title: "Automotive Shot 12", category: "Automotive" },
        { id: 13, url: wix("cb9bb3_0ccd6fb71b8040f49d290821bfc47449~mv2_d_1800_1200_s_2.jpeg"), title: "Automotive Shot 13", category: "Automotive" },
        { id: 14, url: wix("cb9bb3_08c63409738e48c4b867d2032fe212c5~mv2_d_1800_1200_s_2.jpeg"), title: "Automotive Shot 14", category: "Automotive" },
        { id: 15, url: wixTall("cb9bb3_50393cec5248426a87e65b072175d6d3~mv2_d_1200_1800_s_2.jpeg"), title: "Automotive Shot 15", category: "Automotive" },
        { id: 16, url: wix("cb9bb3_64d5b59a6b3f41e1a75a751ca8c849c8~mv2_d_1800_1200_s_2.jpeg"), title: "Automotive Shot 16", category: "Automotive" },
        { id: 17, url: wixTall("cb9bb3_bce2d64634634feb82a69d02d9cce419~mv2_d_1200_1800_s_2.jpeg"), title: "Automotive Shot 17", category: "Automotive" },
      ]
    },
    {
      id: 'weddings',
      name: 'Weddings',
      images: [
        { id: 18, url: wixTall("cb9bb3_bfd8abf889004c5c85ef364b9e0fd1d6~mv2.jpg"), title: "Wedding Shot 1", category: "Weddings" },
        { id: 19, url: wix("cb9bb3_1b7c50ec1ff84808b999296e6f81d3e4~mv2.jpg"), title: "Wedding Shot 2", category: "Weddings" },
        { id: 20, url: wixTall("cb9bb3_0e760fe3e614453aa6e31e9a60711b8b~mv2.jpg"), title: "Wedding Shot 3", category: "Weddings" },
        { id: 21, url: wixTall("cb9bb3_146b453338fb4bd2b1bb0b203c6725f1~mv2.jpg"), title: "Wedding Shot 4", category: "Weddings" },
        { id: 22, url: wixTall("cb9bb3_62c091c9cb0f4444978985ca26ea7790~mv2.jpg"), title: "Wedding Shot 5", category: "Weddings" },
        { id: 23, url: wixTall("cb9bb3_0c81d14765cb40eaabe88535ae546be4~mv2.jpg"), title: "Wedding Shot 6", category: "Weddings" },
        { id: 24, url: wixTall("cb9bb3_9308736f4fb043a69614727eaa19caa4~mv2.jpg"), title: "Wedding Shot 7", category: "Weddings" },
        { id: 25, url: wixTall("cb9bb3_a3aabeac8ea44017bf1b5647e093a70f~mv2.jpg"), title: "Wedding Shot 8", category: "Weddings" },
        { id: 26, url: wixTall("cb9bb3_de6758431ba4486f9667b98202d6ba3e~mv2.jpg"), title: "Wedding Shot 9", category: "Weddings" },
        { id: 27, url: wix("cb9bb3_28352d6fd44143d482045b79dc90fead~mv2.jpg"), title: "Wedding Shot 10", category: "Weddings" },
        { id: 28, url: wixTall("cb9bb3_0b6590c969af41c3a5eb1185a0e13105~mv2.jpg"), title: "Wedding Shot 11", category: "Weddings" },
        { id: 29, url: wixTall("cb9bb3_11dbb430e54d48b6be0a85c58cbceba3~mv2.jpg"), title: "Wedding Shot 12", category: "Weddings" },
        { id: 30, url: wixTall("cb9bb3_6cb5c2c003b34779b3e57f4d4f3d63af~mv2.jpg"), title: "Wedding Shot 13", category: "Weddings" },
      ]
    },
    {
      id: 'events',
      name: 'Events',
      images: [
        { id: 31, url: wix("cb9bb3_a27e0de08cdb472bb63a6ea6d7a10afe~mv2_d_1800_1200_s_2.jpg"), title: "Event Shot 1", category: "Events" },
        { id: 32, url: wix("cb9bb3_cefb87386abf40b68eeb7ae703f75235~mv2_d_1800_1200_s_2.jpg"), title: "Event Shot 2", category: "Events" },
        { id: 33, url: wix("cb9bb3_4b49339291294fdf9dacea32e994b6f2~mv2_d_1800_1200_s_2.jpg"), title: "Event Shot 3", category: "Events" },
        { id: 34, url: wix("cb9bb3_93bebe503e634be9b3696c88f24aafaa~mv2_d_1800_1200_s_2.jpg"), title: "Event Shot 4", category: "Events" },
        { id: 35, url: wix("cb9bb3_dd21d131b00841fe98f8d62bc334802c~mv2_d_1800_1200_s_2.jpg"), title: "Event Shot 5", category: "Events" },
        { id: 36, url: wixTall("cb9bb3_857f8550c886412496601789a570330e~mv2_d_1200_1800_s_2.jpg"), title: "Event Shot 6", category: "Events" },
        { id: 37, url: wix("cb9bb3_dae0c5fcc85e41a0860b5bce046999bb~mv2_d_1800_1200_s_2.jpg"), title: "Event Shot 7", category: "Events" },
        { id: 38, url: wix("cb9bb3_54e0059b09d7451fb20f3c9fc7025395~mv2_d_1800_1200_s_2.jpg"), title: "Event Shot 8", category: "Events" },
        { id: 39, url: wix("cb9bb3_93bb9f5901c94f51b793168c824197f6~mv2_d_1800_1200_s_2.jpg"), title: "Event Shot 9", category: "Events" },
        { id: 40, url: wix("cb9bb3_c732ca2b3a3a406aa40a508a034bc776~mv2_d_1800_1200_s_2.jpg"), title: "Event Shot 10", category: "Events" },
      ]
    },
    {
      id: 'food',
      name: 'Food',
      images: [
        { id: 41, url: wix("cb9bb3_b74122c98be34a69bbb8630a6502c2d3~mv2_d_1800_1200_s_2.jpeg"), title: "Food Shot 1", category: "Food" },
        { id: 42, url: wix("cb9bb3_4e84d517bccb4a3384a6507ff924205c~mv2_d_1800_1200_s_2.jpeg"), title: "Food Shot 2", category: "Food" },
        { id: 43, url: wix("cb9bb3_7e2a3575770642faa50645ba92be7ed1~mv2_d_1800_1200_s_2.jpeg"), title: "Food Shot 3", category: "Food" },
        { id: 44, url: wixTall("cb9bb3_76c852b717a94805b8ae969688746caf~mv2_d_1200_1800_s_2.jpeg"), title: "Food Shot 4", category: "Food" },
        { id: 45, url: wix("cb9bb3_05ae9cd9657b4128a15584cce2d89f7c~mv2_d_1800_1200_s_2.jpeg"), title: "Food Shot 5", category: "Food" },
        { id: 46, url: wix("cb9bb3_c7bffff1da584623afeb058ca943d079~mv2_d_1800_1200_s_2.jpeg"), title: "Food Shot 6", category: "Food" },
        { id: 47, url: wix("cb9bb3_2cb85382a6014fa68a2a7369bf446864~mv2_d_1800_1200_s_2.jpeg"), title: "Food Shot 7", category: "Food" },
        { id: 48, url: wix("cb9bb3_d5cc2015b3514e9caf17f0dd8cec6c19~mv2_d_1800_1200_s_2.jpeg"), title: "Food Shot 8", category: "Food" },
        { id: 49, url: wix("cb9bb3_efe9559ba4764e15912f736a8fd90b56~mv2_d_1800_1200_s_2.jpeg"), title: "Food Shot 9", category: "Food" },
        { id: 50, url: wix("cb9bb3_2dbc9c2315e04dd9862672edfcd1a281~mv2_d_1800_1200_s_2.jpeg"), title: "Food Shot 10", category: "Food" },
        { id: 51, url: wix("cb9bb3_fb6eab37bdc049268fb1e5eb29854d36~mv2_d_1800_1200_s_2.jpeg"), title: "Food Shot 11", category: "Food" },
      ]
    },
    {
      id: 'nature',
      name: 'Nature',
      images: [
        { id: 52, url: wix("cb9bb3_29e0622116c34429877ff01cbd73ca0e~mv2_d_1800_1200_s_2.jpeg"), title: "Nature Shot 1", category: "Nature" },
        { id: 53, url: wix("cb9bb3_3d4cebb4a5294b65b082f4533ca77e58~mv2_d_1800_1200_s_2.jpg"), title: "Nature Shot 2", category: "Nature" },
        { id: 54, url: wix("cb9bb3_156afabb3b804728895ab2ca827f2f65~mv2_d_1800_1200_s_2.jpeg"), title: "Nature Shot 3", category: "Nature" },
        { id: 55, url: wix("cb9bb3_99f3c80a3b6f47ce8b44d71dabed1bc5~mv2.jpeg"), title: "Nature Shot 4", category: "Nature" },
        { id: 56, url: wix("cb9bb3_80945301d85543618bfc57aaba1bea77~mv2_d_1800_1200_s_2.jpg"), title: "Nature Shot 5", category: "Nature" },
        { id: 57, url: wixTall("cb9bb3_9ba0a4e355914ecbb593002de0ee2f1e~mv2_d_1200_1800_s_2.jpg"), title: "Nature Shot 6", category: "Nature" },
        { id: 58, url: wixTall("cb9bb3_11dd51fe95374338b4dee74ab7fc6ed1~mv2_d_1200_1800_s_2.jpg"), title: "Nature Shot 7", category: "Nature" },
        { id: 59, url: wix("cb9bb3_93163e3d37e949b5a68441155e5fc875~mv2_d_1800_1200_s_2.jpg"), title: "Nature Shot 8", category: "Nature" },
        { id: 60, url: wix("cb9bb3_e7c1be68eebb4f43824a52c1ef81088f~mv2_d_1800_1200_s_2.jpg"), title: "Nature Shot 9", category: "Nature" },
        { id: 61, url: wix("cb9bb3_4de99d2e19e64825a89da3c97ff11795~mv2_d_1800_1200_s_2.jpg"), title: "Nature Shot 10", category: "Nature" },
        { id: 62, url: wix("cb9bb3_2b69055d7d6f4a05bf870f67ec6e0c80~mv2_d_1800_1200_s_2.jpg"), title: "Nature Shot 11", category: "Nature" },
        { id: 63, url: wixTall("cb9bb3_a18fde265c724719a6458f5f667ddd93~mv2_d_1200_1800_s_2.jpg"), title: "Nature Shot 12", category: "Nature" },
        { id: 64, url: wix("cb9bb3_ee27438bdde64fddae0571a8026ee21f~mv2_d_1800_1200_s_2.jpg"), title: "Nature Shot 13", category: "Nature" },
      ]
    },
    {
      id: 'people',
      name: 'People',
      images: [
        { id: 65, url: wix("cb9bb3_462c371881364186b0c71ca7f8c350da~mv2_d_1800_1200_s_2.jpg"), title: "People Shot 1", category: "People" },
        { id: 66, url: wix("cb9bb3_6d3f9f304dd842749f3392899321ec86~mv2_d_1800_1200_s_2.jpeg"), title: "People Shot 2", category: "People" },
        { id: 67, url: wix("cb9bb3_1d2fa8f5af6042c594733ccad30c4e31~mv2.jpg"), title: "People Shot 3", category: "People" },
        { id: 68, url: wix("cb9bb3_307987748d894623a26e6603592791b7~mv2_d_1800_1200_s_2.jpeg"), title: "People Shot 4", category: "People" },
        { id: 69, url: wixTall("cb9bb3_b94b088accb142ca82e6e520bbbf917f~mv2_d_1200_1800_s_2.jpeg"), title: "People Shot 5", category: "People" },
        { id: 70, url: wix("cb9bb3_cb13f425a2724f54a4acffce461631b2~mv2_d_1800_1200_s_2.jpeg"), title: "People Shot 6", category: "People" },
        { id: 71, url: wix("cb9bb3_5fb8dee2800d470c99258c4d919bd446~mv2_d_1800_1200_s_2.jpeg"), title: "People Shot 7", category: "People" },
        { id: 72, url: wix("cb9bb3_5b5021c7a8384824951a7c7ddcf8ea5f~mv2_d_1800_1200_s_2.jpeg"), title: "People Shot 8", category: "People" },
        { id: 73, url: wixTall("cb9bb3_83b3e4746a1247618f986c704a2b7b7a~mv2_d_1200_1800_s_2.jpeg"), title: "People Shot 9", category: "People" },
        { id: 74, url: wix("cb9bb3_1ffbd88405e74bbabf4bd6386e60a615~mv2_d_1800_1200_s_2.jpeg"), title: "People Shot 10", category: "People" },
        { id: 75, url: wix("cb9bb3_74814275b8b7430b84db0ddb7d65f824~mv2_d_1800_1200_s_2.jpg"), title: "People Shot 11", category: "People" },
        { id: 76, url: wix("cb9bb3_b5cf1827431b4250a6dbc78d3e3edeeb~mv2_d_1800_1200_s_2.jpeg"), title: "People Shot 12", category: "People" },
        { id: 77, url: wix("cb9bb3_7a4f0b1e45a4414581299ce6b48861db~mv2_d_1800_1200_s_2.jpg"), title: "People Shot 13", category: "People" },
        { id: 78, url: wix("cb9bb3_ded1a35227604703ae5386fe77467c65~mv2.jpg"), title: "People Shot 14", category: "People" },
        { id: 79, url: wixTall("cb9bb3_59fe1fdafc1e44849b5f7a108336f314~mv2_d_1200_1800_s_2.jpeg"), title: "People Shot 15", category: "People" },
        { id: 80, url: wixTall("cb9bb3_f745d476d9684413bb6d5f7af1575bc0~mv2_d_1200_1800_s_2.jpg"), title: "People Shot 16", category: "People" },
      ]
    }
  ],

  testimonials: [
    {
      id: 1,
      name: "Priya & Rahul Sharma",
      role: "Wedding Clients",
      image: wixTall("cb9bb3_bfd8abf889004c5c85ef364b9e0fd1d6~mv2.jpg"),
      text: "Nitin captured our wedding beautifully! His attention to detail and ability to capture candid moments made our album truly special. Highly recommended!",
      rating: 5
    },
    {
      id: 2,
      name: "Amit Patel",
      role: "Corporate Client",
      image: wix("cb9bb3_462c371881364186b0c71ca7f8c350da~mv2_d_1800_1200_s_2.jpg"),
      text: "Professional, creative, and reliable. Nitin's work for our corporate events exceeded expectations. The photos were perfect for our marketing materials.",
      rating: 5
    },
    {
      id: 3,
      name: "Meera Singh",
      role: "Automotive Enthusiast",
      image: wix("cb9bb3_f8f067d7906b46eb9d7385a2eb171ef2~mv2.jpg"),
      text: "Amazing experience! Nitin's automotive photography is on another level. He captured every curve and detail of my car with stunning precision.",
      rating: 5
    }
  ],

  videos: [
    {
      id: 1,
      title: "E-Class v1.2",
      thumbnail: "https://static.wixstatic.com/media/cb9bb3_79b7c3953a424fa0a0d0cda86a3a380ef002.jpg/v1/fill/w_1280,h_720,enc_auto/file.jpeg",
      youtubeId: null,
      category: "Autos & Vehicles"
    },
    {
      id: 2,
      title: "She is an addictive therapy | DUCATI HYPERMOTARD SP | Experience Note",
      thumbnail: "https://i.ytimg.com/vi/0zBe2m7nk3k/maxresdefault.jpg",
      youtubeId: "0zBe2m7nk3k",
      category: "Autos & Vehicles"
    },
    {
      id: 3,
      title: "Immortal forms of motorcycling | Royal Enfield Classic 650 vs BSA Gold Star 650 | Ride review",
      thumbnail: "https://i.ytimg.com/vi/aJOwF7Ngq0c/maxresdefault.jpg",
      youtubeId: "aJOwF7Ngq0c",
      category: "Autos & Vehicles"
    },
    {
      id: 4,
      title: "SUPERNAKED SHOOT-OUT | Ducati Streetfighter V2 VS Triumph Speed Triple RS VS BMW S1000R",
      thumbnail: "https://i.ytimg.com/vi/AauIKV6zNFU/maxresdefault.jpg",
      youtubeId: "AauIKV6zNFU",
      category: "Autos & Vehicles"
    }
  ],

  contact: {
    email: "sharma.nitin0497@gmail.com",
    phone: "+91 9599870968",
    location: "Delhi, India",
    social: {
      instagram: "https://instagram.com/nsphotovideo",
      facebook: "https://facebook.com/nsphotovideo",
      youtube: "https://youtube.com/nsphotovideo"
    }
  }
};
